import {CreateScope, ScopeId, CreateScopeAxis, ScopeAxisId, OwnerId, ScopeIdOrGlobal} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function listMin() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/scopes/min`, {});
}

export async function list() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/scopes`, {});
}

export async function load(scopeIds: ScopeId[]) {
  return await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/scopes/load`, {
    body: scopeIds,
  });
}

export async function create(scope: CreateScope) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/scopes`, {
    body: scope,
  });
  await invalidateQueries([q.vendorToolkit.scopes.filter()]);

  return res;
}

export async function updateName(scopeId: ScopeId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/scopes/{scope_id}/name`,
    {body: name, path: {scope_id: scopeId}},
  );
  await invalidateQueries([q.vendorToolkit.scopes.filter()]);
  return res;
}

export async function getOwner(scopeId: ScopeIdOrGlobal) {
  const res = await platformedClient.internalRequest(
    "get",
    `/region/{region}/api/vendor_toolkit/scopes/{scope_id}/owner`,
    {path: {scope_id: scopeId}},
  );
  return res;
}

export async function assign(scopeId: ScopeIdOrGlobal, owner: OwnerId | null) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/scopes/{scope_id}/assign`,
    {body: owner, path: {scope_id: scopeId}},
  );
  await invalidateQueries([q.vendorToolkit.scopes.filter()]);
  return res;
}

export async function listAxes() {
  return await platformedClient.internalRequest("get", `/region/{region}/api/vendor_toolkit/scope_axes`, {});
}

export async function createAxis(axis: CreateScopeAxis) {
  const res = await platformedClient.internalRequest("post", `/region/{region}/api/vendor_toolkit/scope_axes`, {
    body: axis,
  });
  await invalidateQueries([q.vendorToolkit.scopeAxes.filter()]);
  return res;
}

export async function updateAxisName(axisId: ScopeAxisId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/scope_axes/{axis_id}/name`,
    {body: name, path: {axis_id: axisId}},
  );
  await invalidateQueries([q.vendorToolkit.scopeAxes.filter()]);
  return res;
}

export async function updateAxisColor(axisId: ScopeAxisId, color: string) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/scope_axes/{axis_id}/color`,
    {body: color, path: {axis_id: axisId}},
  );
  await invalidateQueries([q.vendorToolkit.scopeAxes.filter()]);
  return res;
}

export async function updateAccessControls(
  scopeId: ScopeId,
  {reader_ids, writer_ids}: {reader_ids: OwnerId[]; writer_ids: OwnerId[]},
) {
  const res = await platformedClient.internalRequest(
    "post",
    `/region/{region}/api/vendor_toolkit/scopes/{scope_id}/access`,
    {body: {reader_ids, writer_ids}, path: {scope_id: scopeId}},
  );
  await invalidateQueries([q.vendorToolkit.filter()]);
  return res;
}

export async function disableAccessControls(scopeId: ScopeId) {
  const res = await platformedClient.internalRequest(
    "delete",
    `/region/{region}/api/vendor_toolkit/scopes/{scope_id}/access`,
    {path: {scope_id: scopeId}},
  );
  await invalidateQueries([q.vendorToolkit.filter()]);
  return res;
}
